/**
 * @generated SignedSource<<70f27d52f1e1b8c199e9e1a8c04fa5e5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavCreateListing_seller$data = {
  readonly createListingOptions: ReadonlyArray<{
    readonly dataTn: string | null;
    readonly eventName: string | null;
    readonly text: string | null;
    readonly url: string | null;
  } | null> | null;
  readonly isItemUploadV2RedesignWhitelisted: boolean | null;
  readonly serviceId: string | null;
  readonly vertical: string | null;
  readonly " $fragmentType": "NavCreateListing_seller";
};
export type NavCreateListing_seller$key = {
  readonly " $data"?: NavCreateListing_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavCreateListing_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavCreateListing_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": "isItemUploadV2RedesignWhitelisted",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "ITEM_UPLOAD_V2_REDESIGN"
        }
      ],
      "kind": "ScalarField",
      "name": "isWhitelisted",
      "storageKey": "isWhitelisted(listName:\"ITEM_UPLOAD_V2_REDESIGN\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "CreateListingOption",
      "kind": "LinkedField",
      "name": "createListingOptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dataTn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "a2e3aaca2c08e3098ee21149e2fecfa6";

export default node;
